import { useTranslation } from "react-i18next";
import { ActionButton, Modal } from "@dsaui/components";
import routes from "routes";

const externalLinkProps = {
  rel: "noopener noreferrer",
  target: "_blank",
};

export const MembershipCancelDuesModal = ({
  onClose,
  allowWaiver = true,
}: {
  onClose: () => void;
  allowWaiver?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      actions={
        <>
          {allowWaiver ? (
            <ActionButton
              href={routes.external.requestDuesWaiver}
              onClick={onClose}
              {...externalLinkProps}
            >
              {t("membershipPage.modal.requestWaiver")}
            </ActionButton>
          ) : null}
          <ActionButton
            href={routes.external.cancelDues}
            onClick={onClose}
            variant={allowWaiver ? "secondary" : "primary"}
            {...externalLinkProps}
          >
            {t("membershipPage.modal.cancelMembership")}
          </ActionButton>
        </>
      }
      closeLabel={t("membershipPage.modal.close")}
      description={allowWaiver ? t("membershipPage.modal.body") : undefined}
      onClose={onClose}
      title={
        allowWaiver
          ? t("membershipPage.modal.title")
          : t("membershipPage.actions.cancelDues")
      }
    />
  );
};

export default MembershipCancelDuesModal;
